import { fromFetch } from 'rxjs/fetch';
import { FleetJwtAuthHeaders } from '../../models/fleet-jwt-auth-headers';
import { requiredHeaders } from '../../models/required-headers';
import { selectData } from '../../utils/select-data';
import { fleetEnvironment } from './fleet-environment';
import { configurationProfileSchema } from './schemas/configuration-profile.schema';

export function getConfigurationProfilesId(setId: number) {
  return fromFetch(
    new Request(`${fleetEnvironment.configurationProfilesUrl}/${setId}`, {
      method: 'GET',
      headers: {
        ...requiredHeaders,
        ...new FleetJwtAuthHeaders(),
      },
    })
  ).pipe(selectData(configurationProfileSchema));
}
